import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-detail-center-department',
	templateUrl: './detail-center-department.component.html',
	styleUrl: './detail-center-department.component.scss'
})
export class DetailCenterDepartmentComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	centerDepartment: CenterDepartment = null;
	confirmDeleteModalRef: BsModalRef;
	isDeletable: boolean;

	isFormReadOnly = true;

	centerDepartmentDetailForm = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		description: new FormControl('', Validators.maxLength(255))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.isDeletable = this.facade.dataStorageService.isPlanificatrice();
		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.centerDepartmentService.getCenterDepartmentById(id).subscribe({
			next: (centerDepartment: CenterDepartment) => {
				this.centerDepartment = centerDepartment;
				this.resetForm();
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/services/list']);
	}

	delete(centerDepartment: any): void {
		if (this.isDeletable) {
			this.facade.centerDepartmentService
				.deleteCenterDepartment(this.centerDepartment.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.goBack();
					}
				});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
		this.resetForm();
	}

	onSubmit() {
		if (this.centerDepartmentDetailForm.valid) {
			this.isValidateButtonClicked.value = true;
			const userCenter =
				this.facade.dataStorageService.getUser()?.employee.serviceCenter;
			this.centerDepartment.serviceCenter = userCenter;

			this.facade.centerDepartmentService
				.updateCenterDepartment(this.centerDepartment)
				.subscribe({
					complete: () => {
						this.stopEditForm(true);
					},
					error: () => {
						this.stopEditForm(true);
						// On va chercher la nouvelle version de l'employé
						this.facade.centerDepartmentService
							.getCenterDepartmentById(this.centerDepartment.id)
							.subscribe((centerDepartment: CenterDepartment) => {
								this.centerDepartment = centerDepartment;
							});
					}
				});
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	resetForm() {
		this.centerDepartmentDetailForm.reset();
		this.centerDepartmentDetailForm.setValue({
			name: this.centerDepartment.name,
			description: this.centerDepartment.description
		});
	}
}
